var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVarieBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.79 12.22C16.05 11.69 11.66 11 9.97998 11C5.96998 11 2.72998 17.94 2.72998 25C2.72998 32.06 5.97998 39 9.97998 39C11.67 39 16.12 38.54 17.79 37.78C21.49 36.1 25.04 32.06 25.04 25C25.04 17.94 21.64 13.4 17.79 12.22Z",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 35.0701C22.83 36.2401 24.1699 37.0701 25.6099 37.0701C27.2999 37.0701 25.0399 37.0701 26.7299 37.0701C30.74 37.0701 33.9799 31.5001 33.9799 25.0001C33.9799 18.5001 30.7299 12.9301 26.7299 12.9301C25.0399 12.9301 27.2999 12.9301 25.6099 12.9301C24.1699 12.9301 23.05 13.6201 21.92 14.7901",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.29 35.12C32.27 35.9 33.37 36.11 34.53 36.11C36.22 36.11 33.96 36.11 35.65 36.11C39.66 36.11 41.79 31.39 41.79 25.01C41.79 18.63 39.66 13.91 35.65 13.91C33.96 13.91 36.22 13.91 34.53 13.91C33.36 13.91 32.26 14 31.29 14.78",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97998 11C12.24 11 14.3 12.39 15.8 14.65C17.34 16.97 18.29 21.42 18.29 25C18.29 28.58 17.31 31.9 15.73 34.22",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 25.78C20.86 26.58 23.04 26.62 25.05 24.47C27.42 26.98 31.08 27.43 33.74 25.52C36.67 28.03 40.88 27.12 41.79 25.52",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66992 23.55V25.48",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 21.62V23.55",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5601 27.41V29.34",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.46 27.51C41.46 27.51 44.9 30.02 46.29 29.17C47.68 28.32 47.53 24.05 46.29 22.89C45.05 21.73 41.46 24.59 41.46 24.59",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVarieBlack);
export default __webpack_public_path__ + "static/media/ic_varie_black.2ef2b04c2b320d398346c7ef3db3d099.svg";
export { ForwardRef as ReactComponent };